export default __webpack_public_path__ + "static/media/iside-logo-dark.2e1e1c9e.png";